import styled from 'styled-components';

import { animateIn, animateOut } from './utils';

export default styled.div`
  .modal,
  .scrim {
    transition: opacity 0.2s, transform 0.2s;
  }

  ${animateIn} {
    .modal {
      opacity: 1;
      transform: scale(1);
    }
    .scrim {
      opacity: 1;
    }
  }
  ${animateOut} {
    .modal {
      opacity: 0;
      transform: scale(0.97);
    }
    .scrim {
      opacity: 0;
    }
  }
`;
